const Toaster = ({ children }) => {
  return (
    <div className="bg-red white pad-5 text-center rounded shadow text-lg">
      {children}
    </div>
  );
};

export default Toaster;
